<script >
	
	import { registerUser } from "../../api/Register";
	import { validatePassword } from "../../services/passwordValidator";
	import {validateEmail} from "../../services/emailValidator";

	export let changeToLogin = true;

	let userData = {

		FirstName: "",
		LastName: "",
		Email: "",
		Username: "",
		Password: ""
	}

	let errorMessage = '';

	let invalidPassword = false;
	let invalidPasswordText = "Password does not meet minimal requirements."

	let invalidEmail = false;
	let invalidEmailText = "Please enter a valid email address.";

	

	let passwordRequirements = {

		min: false,
		uppercase: false,
		lowercase: false,
		digits: false
	}


	function handleGoToLoginBtn(){

		changeToLogin = false;
	}

	async function handleRegisterBtn(){

		if(invalidPassword == false && invalidEmail == false && userData.Password != '' && userData.Email != '' 
			&& userData.FirstName != '' &&  userData.LastName != '' && userData.Username != '' ){

			const res = await registerUser(userData);

			// console.log('res: ', res);

			if(res.status == "valid"){

				// alert('Welcome helder!');
				localStorage.setItem('user', JSON.stringify(res.user));
	      		localStorage.setItem('token', res.token);
	      		window.location.href = '/';

			}	
			else if(res.status == "error"){

				if(res.code = "EAE"){
					errorMessage = res.error;
					userData.Email = '';
					var el = document.getElementById("Email");
					el.classList.remove('loginInput');
					el.classList.add('errorLoginInput');

				}
				else if(res.code = "RF"){
					errorMessage = res.error;
				}
			}
		}
		else{
			errorMessage = 'Invalid fields.';
		}
		
	}


	$:{
		if(userData.Password != ''){

			let res = validatePassword(userData.Password);

			// console.log('pass res:', res);

			if(res.status == true){

				invalidPassword = false;

			}
			else if(res.status == false){

				invalidPassword = true;

				if(!res.details.includes("min")){
					passwordRequirements.min = true;
				}
				else{
					passwordRequirements.min = false;	
				}

				if(!res.details.includes("uppercase")){
					passwordRequirements.uppercase = true;
				}
				else{
					passwordRequirements.uppercase = false;	
				}

				if(!res.details.includes("lowercase")){
					passwordRequirements.lowercase = true;
				}
				else{
					passwordRequirements.lowercase = false;	
				}

				if(!res.details.includes("digits")){
					passwordRequirements.digits = true;
				}
				else{
					passwordRequirements.digits = false;	
				}

			} 

		}
		else{

		}
	}

	$:{
		if(userData.Email != ''){
			let res = validateEmail(userData.Email);

			invalidEmail = !res;

			if(invalidEmail == true){

			}
		}
		else{

		}
	}

</script>

<div class="loginContainer">

	<div class="logoContainer">
		<div class="artisaneLogo"></div>
	</div>

	<div class="loginInputContainer">
		<p class="errorMessage">{errorMessage}</p>
		<input bind:value={userData.FirstName} class="loginInput" type="text" name="First Name"  placeholder="First Name">
		<input bind:value={userData.LastName} class="loginInput" type="text" name="Last Name"  placeholder="Last Name">
		<input bind:value={userData.Email} class="loginInput" type="email" name="Email" id="Email" placeholder="Email">

		{#if invalidEmail}
			<div class="passwordDetails">

				<div class="errorMessage">{invalidEmailText}</div>
			</div>
		{:else}
		
		{/if}

		<!-- <input bind:value={userData.Company} class="loginInput" type="text" name="Company Name"  placeholder="Company Name"> -->
		<input bind:value={userData.Username} class="loginInput" type="text" name="Username"  placeholder="Username">
		<input bind:value={userData.Password}  class="loginInput" type="password" name="Password" placeholder="Password">
		{#if invalidPassword}
			<div class="passwordDetails">

				<div class="errorMessage">{invalidPasswordText}</div>

				{#if passwordRequirements.min}
					<div class="passwordDetailsItem itemChecked">Minimum length of 8 characters 🗸</div>
				{:else}
					<div class="passwordDetailsItem itemNotChecked">Minimum length of 8 characters</div>
				{/if}

				{#if passwordRequirements.uppercase}
					<div class="passwordDetailsItem itemChecked">1 Uppercase 🗸</div>
				{:else}
					<div class="passwordDetailsItem itemNotChecked">1 Uppercase</div>
				{/if}

				{#if passwordRequirements.lowercase}
					<div class="passwordDetailsItem itemChecked">1 Lowercase 🗸</div>
				{:else}
					<div class="passwordDetailsItem itemNotChecked">1 Lowercase</div>
				{/if}

				{#if passwordRequirements.digits}
					<div class="passwordDetailsItem itemChecked">1 Digit 🗸</div>
				{:else}
					<div class="passwordDetailsItem itemNotChecked">1 Digit</div>
				{/if}
				
			</div>
		{:else}

		{/if}
		
	</div>

	<div class="loginActionsContainer">

		<!-- <div class="sessionContainer">

			<div class="keepMeLogedInContainer">

				<input class="checkBox" type="checkbox" id="keepMeLogedIn" name="keepMeLogedIn" unchecked>

					<div class="ckeckBoxLabel" for="keepMeLogedIn">Keep me loged in</div>

			</div>

			<a class="passwordRecoveryLink">Forgot your password?</a>
			
		</div> -->

		<div on:click={handleRegisterBtn} class="loginSubmitBtn">Join us</div>
		<div class="goToRegisterText">
			You already have an account?

			<a on:click={handleGoToLoginBtn} class="goToRegisterLink">Log In.</a>

		</div>
	</div>
</div>


<style>

:global(.errorLoginInput) {
        	width: 90%;
		/*height: 40px;*/
		height: 5.54016620498615vh;
		border: 1px solid red;
		border-radius: 3px;	
}



/* register section for mobile*/
@media only screen and (max-width: 600px){
	.loginContainer{
			width: 50%;
			height: 100%;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;

		}

		.logoContainer{
			width: 50%;
			height: auto;
			display: flex;
			align-items: center;
			justify-content: center;
		}
		.artisaneLogo{
			width: 200px;
			height: 200px;
			background-image: url('/img/logos/artisaneBig.png');
			background-repeat: no-repeat;
			background-size: contain;
			background-position: center center;
		}


		.loginInputContainer{
			width: 50%;
			height: auto;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
		}

		.errorMessage{
			font-size: 12px;
			color: red;
		}


		.loginInput{
			width: 90%;
			height: 5.54016620498615vh;
			border: 1px solid #ccc;
			border-radius: 3px;
		}

		.passwordDetails{
			width: 90%;
			height: 5.54016620498615vh;
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: center;
			flex-wrap: wrap;
			margin-bottom: 2%;
			will-change: transform;
		}

		.passwordDetailsItem{
			font-size: 0.7161458333333334vw;
			margin-right: 2%;
		}

		.itemNotChecked{
			opacity: 0.5;
		}

		.itemChecked{
			opacity: 1;
		}

		

		.loginActionsContainer{
			width: 50%;
			height: auto;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
		}


		.sessionContainer{
			width: 90%;
			height: 5.54016620498615vh;
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: center;
			margin-top:2% ;
		}

		.keepMeLogedInContainer{
			width: 50%;
			height: auto;
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: flex-start;
			
		}

		.checkBox{
			width: 1.3020833333333333vw;
			height:2.770083102493075vh ;
		}

		.ckeckBoxLabel{
			width: 90% ;
			height: auto;
			display: flex;
			justify-content: center;
			line-height: 60%;
			font-size: 0.9114583333333334vw;
		}

		.passwordRecoveryLink{
			width: 50%;
			height: auto;
			color: black;
			opacity: 0.3 !important;
			display: flex;
			line-height: 60%;
			justify-content: flex-end;
			cursor: pointer;
			font-size: 0.9114583333333334vw;
		}

		.loginSubmitBtn{
			width: 90%;
			height: 5.54016620498615vh;
			background-color: black;
			color:  white;
			display: flex;
			align-items: center;
			justify-content: center;
			margin-top:5% ;
			border-radius: 3px;
			cursor: pointer;
			font-size: 0.9114583333333334vw;
		}

		.goToRegisterText{
			margin-top:5% ;
			font-size: 0.9114583333333334vw;
		}

		.goToRegisterLink{
			color: #EF9144;
			text-decoration: underline;
			cursor: pointer;
		}

		.goToRegisterLink:hover{
			opacity: 0.8;
		}
		.goToRegisterLink:active{
			color: black;
		}
}

/*Register section for desktop*/
@media only screen and (min-width: 768px){
	.loginContainer{
			width: 50%;
			height: 100%;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			/*background-color: red;*/

		}

		.logoContainer{
			width: 50%;
			height: auto;
			display: flex;
			align-items: center;
			justify-content: center;
			/*background-color: gray;*/
		}
		.artisaneLogo{
			width: 200px;
			height: 200px;
			background-image: url('/img/logos/artisaneBig.png');
			background-repeat: no-repeat;
			background-size: contain;
			background-position: center center;
		}


		.loginInputContainer{
			width: 50%;
			height: auto;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			/*background-color: gray;*/
			/*gap:5px;*/
		}

		.errorMessage{
			font-size: 12px;
			color: red;
		}


		.loginInput{
			width: 90%;
			/*height: 40px;*/
			height: 5.54016620498615vh;
			border: 1px solid #ccc;
			border-radius: 3px;
		}

		.passwordDetails{
			width: 90%;
			/*height: 40px;*/
			height: 5.54016620498615vh;
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: center;
			flex-wrap: wrap;
			margin-bottom: 2%;
			will-change: transform;
		}

		.passwordDetailsItem{

			/*font-size: 11px;*/
			font-size: 0.7161458333333334vw;
			margin-right: 2%;
		}

		.itemNotChecked{
			opacity: 0.5;
		}

		.itemChecked{
			opacity: 1;
		}

		

		.loginActionsContainer{
			width: 50%;
			height: auto;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
		}


		.sessionContainer{
			width: 90%;
			/*height: 40px;*/
			height: 5.54016620498615vh;
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: center;
			margin-top:2% ;
		}

		.keepMeLogedInContainer{
			width: 50%;
			height: auto;
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: flex-start;
			
		}

		.checkBox{
			/*width: 20px;*/
			/*height: 20px;*/
			width: 1.3020833333333333vw;
			height:2.770083102493075vh ;
		}

		.ckeckBoxLabel{
			width: 90% ;
			height: auto;
			display: flex;
			justify-content: center;
			line-height: 60%;
			font-size: 0.9114583333333334vw;
		}

		.passwordRecoveryLink{
			width: 50%;
			height: auto;
			color: black;
			opacity: 0.3 !important;
			display: flex;
			line-height: 60%;
			justify-content: flex-end;
			cursor: pointer;
			font-size: 0.9114583333333334vw;
		}

		.loginSubmitBtn{
			width: 90%;
			/*height: 40px;*/
			height: 5.54016620498615vh;
			background-color: black;
			color:  white;
			display: flex;
			align-items: center;
			justify-content: center;
			margin-top:5% ;
			border-radius: 3px;
			cursor: pointer;
			font-size: 0.9114583333333334vw;
		}

		.goToRegisterText{
			margin-top:5% ;
			font-size: 0.9114583333333334vw;
		}

		.goToRegisterLink{
			color: #EF9144;
			text-decoration: underline;
			cursor: pointer;
		}

		.goToRegisterLink:hover{
			opacity: 0.8;
		}
		.goToRegisterLink:active{
			color: black;
		}
}
</style>